
import { useScenario } from "../contexts/ScenarioContext"

import Panel from "./Panel"

const InterventionsPerformed = () => {
    const {intvsPerformedCollapsed, toggleIntvsPerformedCollapsed} = useScenario()

    return (
        <Panel
            title="Intervention History"
            collapsable={true}
            initialCollapseState={intvsPerformedCollapsed}
            customCollapsedState={intvsPerformedCollapsed}
            customCollapseToggler={toggleIntvsPerformedCollapsed}
        >
            <p>Coming soon. a list of completed interventions, along with results, if applicable</p>
        </Panel>
    )
}

export default InterventionsPerformed